import axios from 'axios';
import router from '@/router';
import { closeNotify, showFailToast, showNotify, showSuccessToast } from "vant";

// 创建 Axios 实例
// const service = axios.create({
//     baseURL: 'http://192.168.3.76:8000', // 后端 API 的基础 URL
//     timeout: 20000 // 请求超时时间
// });

// const service = axios.create({
//     baseURL: 'http://47.121.124.27/dev-quantview/api', // 后端 API 的基础 URL
//     timeout: 20000 // 请求超时时间
// });

const service = axios.create({
    baseURL: 'https://quantview.bosenkeji.cn/api', // 后端 API 的基础 URL
    timeout: 15000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么，例如添加 token
        let token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        } else {
            config.headers['Authorization'] = `Bearer 1`;
        }
        return config;
    },
    error => {
        // 处理请求错误
        console.error('请求拦截器错误:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做点什么，例如统一处理成功响应
        // 如果返回的状态码为 401，说明 token 认证失败
        console.log(response)
        if (response.data.code === -10003) {
            console.error("Token认证失败，进行处理！");
            // 清除本地存储的 token
            // localStorage.removeItem('token');
            // 这里可以加入更多的处理逻辑，比如重定向到登录页面、弹出提示等
            showNotify({message: "登录已过期，请重新登录！", type: 'warning'})
            router.push('/login')

        }
        return response.data;

    },
    error => {
        // 处理响应错误，例如统一处理错误状态码
        console.error('响应拦截器错误:', error);
        // return Promise.reject(error);
        return Promise.reject(error);
    }
);

export default service;